import './Game.scss';
import store, { RootState } from '../store';
import { useAppSelector } from '../redux'
import { gameActions } from '../Game/gameSlice'
import { GamePlayState, DefaultEnums } from "../Enums/GameEnums";
import BlackjackCards from './BlackjackCards';
import { useState } from 'react';
import SpritesheetAsset from '../Components/SpritesheetAsset';

function PlayerBlackjack() {
  const gameState = useAppSelector((state: RootState) => state.game)
  const bet = gameState.bet
  const minimalBet = gameState.player.attributes.att < 0 ? gameState.player.attributes.att : 0;
  const engineState = gameState.engineState
  const gamePlayState = gameState.gamePlayState

  const [disabledByTimeout, setDisabledByTimeout] = useState(false);

  function handleDeal() {

    store.dispatch(gameActions.deal(bet));

    setDisabledByTimeout(true);

    setTimeout(() => {

      if (gameState.gamePlayState !== GamePlayState.DEFEAT) {
        store.dispatch(gameActions.processDeal());
      }

      setDisabledByTimeout(false);
    }, DefaultEnums.DEFAULT_TIMEOUT);
  }

  function handleHit(isDisabled = false) {
    if (isDisabled) {
      return;
    }

    store.dispatch(gameActions.hit());
    setDisabledByTimeout(true);

    setTimeout(() => {

      if (gameState.gamePlayState !== GamePlayState.DEFEAT) {
        store.dispatch(gameActions.processHit());
      }

      setDisabledByTimeout(false);
    }, DefaultEnums.DEFAULT_TIMEOUT);
  }

  function handleStand(isDisabled = false) {

    if (isDisabled) {
      return;
    }

    store.dispatch(gameActions.stand());

    setDisabledByTimeout(true);

    setTimeout(() => {
      if (gameState.gamePlayState !== GamePlayState.DEFEAT) {
        store.dispatch(gameActions.resolve());
        setDisabledByTimeout(false);
      }
    }, DefaultEnums.DEFAULT_TIMEOUT)
  }

  const shouldShowActionButtons =
    gamePlayState === GamePlayState.PLAYER_CARD_REVEAL ||
    gamePlayState === GamePlayState.PLAYER_ACTION ||
    gamePlayState === GamePlayState.DEALER_CARD_REVEAL;

  const shouldDisableActionButtons = gamePlayState === GamePlayState.DEALER_CARD_REVEAL || disabledByTimeout;

  return (
    <div className="player-blackjack">
      {shouldShowActionButtons &&
        <div className="player-blackjack_cards">
          <BlackjackCards
            isMuted={gameState.isMuted}
            cards={engineState?.handInfo?.right?.cards}
            label={engineState?.handInfo.right?.playerValue}
            owner={"player"}
          />
        </div>
      }

      <div className="action-buttons">
        {shouldShowActionButtons &&
          <>
            <SpritesheetAsset animate={true} multiplier={4} onClick={() => handleHit(shouldDisableActionButtons)} disabled={shouldDisableActionButtons} showPointerOnHover={true} name='hit.png' />
            <SpritesheetAsset animate={true} multiplier={4} onClick={() => handleStand(shouldDisableActionButtons)} disabled={shouldDisableActionButtons} showPointerOnHover={true} name='stand.png' />
          </>
        }
      </div>

      {gamePlayState === GamePlayState.BETTING && (bet + minimalBet) > 0 &&
        <div>
          <SpritesheetAsset animate={true} multiplier={4} onClick={handleDeal} showPointerOnHover={true} name='deal.png' />
        </div>
      }
    </div>
  );
}

export default PlayerBlackjack;
